import React from 'react';
import Modal from './Modal';
import Button from './Button';

const ForkLiveDraftModal = ({
    isOpen,
    onClose,
    onConfirm,
    isConfirming = false,
    draftName,
    isLive = true
}) => {
    const draftLabel = draftName ? `"${draftName}"` : (isLive ? 'this live schedule' : 'this snapshot');

    return (
        <Modal
            isOpen={isOpen}
            onClose={isConfirming ? undefined : onClose}
            title={isLive ? 'This version is live' : 'This snapshot cannot be edited'}
            containerClassName="max-w-lg max-h-[80vh]"
        >
            <div className="space-y-4">
                <p className="text-sm text-gray-600">
                    {isLive
                        ? `Students and teachers currently see ${draftLabel}. Start a working copy — live stays unchanged until you publish it.`
                        : `${draftLabel} is a history snapshot. Open a working copy to edit — live stays unchanged until you publish it.`}
                </p>
                <div className="flex justify-end gap-2 pt-2">
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={onClose}
                        disabled={isConfirming}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="primary"
                        onClick={onConfirm}
                        disabled={isConfirming}
                    >
                        {isConfirming ? 'Creating…' : 'Start editing'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ForkLiveDraftModal;
